<template>
    <div class="content">
        <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
            <contracts-memo>
            </contracts-memo> 
            </div>
        </div>  
        </div>
    </div>
    </template>
    <script>
    /* eslint-disable */
    import contractsMemo from './todo-contracts-memo'
    export default {
        components: {
            contractsMemo
        }
    }
    </script>
    <style lang="scss">
        .bg-breadcrum{
            background:#fff;
        }
        .img-custom{
            border-radius:100px; 
        }
    </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-contracts-memo/base-contracts-memo.vue